import React, {useEffect, useState} from "react";
import {useAppDispatch, useAppSelector} from 'redux/hooks'
import {Divider} from "primereact/divider";
import {Button} from "primereact/button";
import {TabPanel, TabView} from "primereact/tabview";
import {Dialog} from "primereact/dialog";
import {ConfirmDialog} from "primereact/confirmdialog";
import {ProgressBar} from "primereact/progressbar";
import {checkPermissions} from "../../../redux/permissions/permissionsUtils";
import {codes} from "redux/notificationCodes";
import {getItem} from "redux/cache/cacheService";
import {setQueueDialogVisible, setQueueErrorField} from "../../../redux/actions/actionsQueue";
import QueuesDialogInfo from "../QueuesDialogInfo";
import QueuesListDialogManagement from "../DialogManagement";
import QueuesListDialogGeneralSettings from "../DialogGeneralSettings";
import QueueListDialogUsers from "../QueueDialogUsers";
import QueueWorkSetting from "../QueueWorkSetting";
import ACDSettingsTab from "../QueueDialogACD";
import {getUsers} from "../../../redux/api/api";
import {createQueue, getQueueDirectoriesGetTranksPhones, setArchiveQueueById, updateQueue} from "../../../redux/api/apiQueue";
import {validateQueueData} from "../../../redux/validator/validator";
import {getNotificationMessage} from "../../../redux/api/apiNotifications";
import {getSkillGroupList} from "../../../redux/api/apiQualificationGroup";
import QueueDialog_IVR_ACD from "../QueueDialog_IVR_ACD";
import IVRScheme from "../QueueScheme";

const QueuesListDialog = (props: any) => {
    const dispatch = useAppDispatch()
    const companies = useAppSelector(state => state.CompaniesListReducer);
    const queueData = useAppSelector(state => state.QueueListReducer.queueData);
    const dialogVisible = useAppSelector(state => state.QueueListReducer.queueDialogVisible);
    // @ts-ignore
    const queueTrankIds = useAppSelector(state => state.QueueListReducer.queueTrunkIds);
    const companyStateSave = useAppSelector(state => state.CompaniesListReducer.companyStateSave);
    const archiveTableToggle = useAppSelector(state => state.QueueListReducer.archiveQueueTableToggle);
    const changeScheduler = useAppSelector(state => state.CompaniesListReducer.changeScheduler)
    const user = useAppSelector(state => state.UsersReducer.userData);
    const [activeIndex, setActiveIndex] = useState(0);
    const [selectIndex, setSelectIndex] = useState(0);
    const [showDeleteNotification, setShowDeleteNotification] = useState<boolean>(false);
    const [showSaveChangeNotification, setShowSaveChangeNotification] = useState<boolean>(false);
    const [createdSchedule, setCreatedSchedule] = useState<boolean>(false);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const [visible, setVisible] = useState(false);
    const saveChangesNotification = getItem(codes.save_changes);
    const progressBar = <ProgressBar mode="indeterminate" style={{height: '2px', maxWidth: '95%'}}></ProgressBar>;
    const saveChangeMessage = <div>{companies && companies.notificationSaveChanges ? companies.notificationSaveChanges.text : saveChangesNotification ? saveChangesNotification : progressBar}</div>
    const rolesVision = useAppSelector(state => state.RolesReducer.rolesVision) as unknown as Record<string, string[]>;
    const errorFields = useAppSelector(state => state.CompaniesListReducer.errorFields);
    let archiveQueueNotification = getItem(codes.archive_queue_question);
    const archiveQueueMessage = useAppSelector(state => state.NotificationsReducer.archiveQueueMessage);
    const deleteQueueQuestion = <div>{archiveQueueMessage && archiveQueueMessage?.text ? archiveQueueMessage?.text : archiveQueueNotification ? archiveQueueNotification : progressBar}</div>
    const dialerPermissions = checkPermissions(rolesVision, 'Queues');
    const skillGroupList = useAppSelector(state => state.QualificationGroupListReducer.skillGroupList);
    const jwtToken = useAppSelector(state => state.UsersReducer.userData.jwtToken);

    const {
        create: hasQueuesCreatePermission,
        update: hasQueuesUpdatePermission,
        delete: hasQueuesDeletePermission,
    } = dialerPermissions;

    const queuePermission = queueData?.permission;
    const detailsLoading = useAppSelector(state => state.QueueListReducer.detailsLoading);
    const queueId = queueData?.queue?.id;
    // @ts-ignore
    const allAudioGroup = useAppSelector(state => state.QueueListReducer.allAudioGroup);
    const queuesDirectoryQueueAudioType = useAppSelector(state => state.QueueListReducer.queuesDirectoryQueueAudioType);

    const resolveSkillGroupName = (row: any) => {
        if (row?.name) {
            return row.name;
        }
        const sg = skillGroupList?.find(
            (s: any) =>
                s?.id != null &&
                (row?.skillGroupId ?? row?.id) != null &&
                String(s.id) === String(row.skillGroupId ?? row.id)
        );
        return sg?.name || '';
    };

    const resolveAudioMeta = (audioId: any) => {
        const fromGroups = allAudioGroup?.find((a: any) => a.audioId === audioId);
        if (fromGroups) {
            return fromGroups;
        }
        return queuesDirectoryQueueAudioType?.find((a: any) => a.audioId === audioId);
    };

    const withQueuePayload = (data: typeof queueData) => {
        const qid = data?.queue?.id;
        const queueACD = data.queueACD
            ? {
                ...data.queueACD,
                ivmAudios: (data.queueACD.ivmAudios ?? []).map((audio: any, index: number) => {
                    const meta = resolveAudioMeta(audio.audioId);
                    return {
                        ...audio,
                        audioId: audio.audioId,
                        order: audio.order ?? index + 1,
                        audioName: audio.audioName || meta?.audioName || '',
                        groupName: audio.groupName || meta?.groupName || '',
                        groupId: audio.groupId ?? meta?.groupId,
                    };
                }),
                mohAudioName:
                    data.queueACD.mohAudioName ||
                    resolveAudioMeta(data.queueACD.mohAudioId)?.audioName ||
                    '',
                mohAudioGroupName:
                    data.queueACD.mohAudioGroupName ||
                    resolveAudioMeta(data.queueACD.mohAudioId)?.groupName ||
                    '',
                schedulerAudioName:
                    data.queueACD.schedulerAudioName ||
                    resolveAudioMeta(data.queueACD.schedulerAudioId)?.audioName ||
                    '',
                schedulerAudioGroupName:
                    data.queueACD.schedulerAudioGroupName ||
                    resolveAudioMeta(data.queueACD.schedulerAudioId)?.groupName ||
                    '',
            }
            : data.queueACD;

        return {
            ...data,
            queueACD,
            skillGroups: (data.skillGroups ?? []).map((g: any) => ({
                ...g,
                skillGroupId: g.skillGroupId,
                skillGroupLevel: g.skillGroupLevel ?? 0,
                queueId: g.queueId ?? qid,
                name: resolveSkillGroupName(g),
            })),
            skillGroupsGarbage: (data.skillGroupsGarbage ?? []).map((g: any) => ({
                ...g,
                skillGroupId: g.skillGroupId,
                displayOrder: g.displayOrder ?? g.skillGroupLevel,
                queueId: g.queueId ?? qid,
                name: resolveSkillGroupName(g),
            })),
        };
    };

    useEffect(() => {
        setActiveIndex(0);
    }, [dialogVisible]);

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {
        if (!dialogVisible) {
            return;
        }
        // Wait until GetQueueById finishes so permission flags are from API, not defaults
        if (detailsLoading) {
            return;
        }
        if (!queuePermission?.usersIsBlock) {
            dispatch(getUsers(jwtToken?.jwtToken, true));
        }
        if (!queuePermission?.trunksIsBlock) {
            dispatch(getQueueDirectoriesGetTranksPhones(jwtToken?.jwtToken));
        }
        if (!queuePermission?.skillGroupsIsBlock) {
            dispatch(getSkillGroupList(jwtToken?.jwtToken, true));
        }
    }, [
        dialogVisible,
        detailsLoading,
        queueId,
        queuePermission?.usersIsBlock,
        queuePermission?.skillGroupsIsBlock,
        queuePermission?.trunksIsBlock,
        jwtToken?.jwtToken,
    ]);

    useEffect(() => {
        if (!user?.userId) {
            return;
        }
        if (!getItem(codes.archive_queue_question) && !archiveQueueMessage) {
            dispatch(getNotificationMessage(user.userId, 171, user));
        }
    }, [user?.userId, dispatch, archiveQueueMessage]);

    useEffect(() => {
        if (errorFields && errorFields?.nameUniq) {
            setActiveIndex(0);
        }
    }, [errorFields])

    const closeDialogVisible = () => {
        dispatch(setQueueDialogVisible(false));
        dispatch(setQueueErrorField(null));
    }

    const updateCampaign = (type: string) => {
        let queueCopy = {...queueData};

        if (!queuePermission?.trunksIsBlock) {
            queueCopy.queueTrunks = [...(queueTrankIds || [])];
        }

        const validationErrors = validateQueueData(queueCopy);
        if (!validationErrors) {
            if (queueCopy?.queue?.isGeneralTrunk === false && Array.isArray(queueCopy.queueTrunks)) {
                const trunks = queueCopy.queueTrunks;

                const index = trunks.findIndex((item: { trunkId: any; }) => item.trunkId === null);

                if (index !== -1) {
                    if (trunks.length === 1) {
                        queueCopy.queueTrunks = null;
                    } else {
                        trunks.splice(index, 1);
                    }
                }
            }
            const payload = withQueuePayload(queueCopy);
            if (props?.branchId) {
                dispatch(updateQueue(payload, jwtToken?.jwtToken, props?.branchId));
            } else {
                dispatch(updateQueue(payload, jwtToken?.jwtToken));
            }

            if (type === 'with_close') {
                closeDialogVisible();
            }
        } else {
            dispatch(setQueueErrorField(validationErrors));
            if (validationErrors.name || validationErrors.queueTranks || validationErrors.branchId) {
                setActiveIndex(0);
            } else if (validationErrors.scheduler) {
                setActiveIndex(2);
            } else if (validationErrors.queueUsers) {
                setActiveIndex(1);
            } else if (validationErrors.mohAudioTime ||  validationErrors.mohAudioId || validationErrors?.schedulerAudioId || validationErrors.mwtNoAgentAudioTime || validationErrors.mwtAudioTime || validationErrors.schedulerAudioTime || validationErrors.schedulerStrategyAction || validationErrors.mwtStrategyAction || validationErrors.mwtNoAgentStrategyAction || validationErrors.mwtNoAgent || validationErrors.mwt || validationErrors.mwtStrategy || validationErrors.mwtNoAgentStrategy || validationErrors.schedulerStrategy) {
                setActiveIndex(3);
            }
            else if (queueData?.queue?.queueType === 702 && validationErrors?.audioRetries) {
                setActiveIndex(4);
            }
            else if (queueData?.queue?.queueType === 702 && (validationErrors?.ivrConfiguration || validationErrors?.ivrConfigurationId)) {
                setActiveIndex(4);
            }
        }
        setCreatedSchedule(false);
    };

    const createCampaign = (type: string) => {
        let queueCopy = {...queueData};

        if (!queuePermission?.trunksIsBlock) {
            queueCopy.queueTrunks = [...(queueTrankIds || [])];
        }

        const validationErrors = validateQueueData(queueCopy);

        if (!validationErrors) {
            if (queueCopy?.queue?.isGeneralTrunk === false && Array.isArray(queueCopy.queueTrunks)) {
                const trunks = queueCopy.queueTrunks;

                const index = trunks.findIndex((item: { trunkId: any; }) => item.trunkId === null);

                if (index !== -1) {
                    if (trunks.length === 1) {
                        queueCopy.queueTrunks = null;
                    } else {
                        trunks.splice(index, 1);
                    }
                }
            }

            dispatch(createQueue(withQueuePayload(queueCopy), jwtToken?.jwtToken))

            if (type === 'with_close') {
                closeDialogVisible();
            }
        } else {
            dispatch(setQueueErrorField(validationErrors));
            if (validationErrors.name || validationErrors.queueTranks || validationErrors?.branchId) {
                setActiveIndex(0);
            } else if (validationErrors?.scheduler) {
                setActiveIndex(2);
            } else if (validationErrors?.queueUsers) {
                setActiveIndex(1);
            } else if (validationErrors.mohAudioTime ||  validationErrors.mohAudioId || validationErrors?.schedulerAudioId || validationErrors.mwtNoAgentAudioTime || validationErrors.mwtAudioTime || validationErrors.schedulerAudioTime || validationErrors.schedulerStrategyAction || validationErrors.mwtStrategyAction || validationErrors.mwtNoAgentStrategyAction || validationErrors.mwtNoAgent || validationErrors.mwt || validationErrors.mwtStrategy || validationErrors.mwtNoAgentStrategy || validationErrors.schedulerStrategy) {
                setActiveIndex(3);
            } else if (queueData?.queue?.queueType === 702 && validationErrors?.audioRetries) {
                setActiveIndex(4);
            }
            else if (queueData?.queue?.queueType === 702 && (validationErrors?.ivrConfiguration || validationErrors?.ivrConfigurationId)) {
                setActiveIndex(4);
            }
        }
        setCreatedSchedule(false);
    };

    const deleteCampaign = () => {
        if (jwtToken?.jwtToken) {
            dispatch(setArchiveQueueById(queueData?.queue?.id, jwtToken?.jwtToken));
        }
        dispatch(setQueueDialogVisible(false));
    }

    const showDeletionNotification = () => {
        if (!archiveQueueNotification && !archiveQueueMessage && user?.userId) {
            dispatch(getNotificationMessage(user.userId, 171, user));
        }
        setShowDeleteNotification(true);
    }

    const showSaveChangesNotification = () => {
        dispatch(setQueueDialogVisible(false));
    }

    const setActiveTabIndex = (e: any) => {
        if ((createdSchedule || changeScheduler) && activeIndex === 2) {
            setVisible(true);
            setSelectIndex(e.index);
        } else {
            setActiveIndex(e.index);
        }
    }

    const closeNotification = () => {
        setVisible(false);
        setActiveIndex(selectIndex);
        setCreatedSchedule(false);
    }

    const saveNewScheduler = () => {
        closeNotification();
    }

    const cancelSaveScheduler = () => {

    }

    const footer = (
        <div className="dialog-footer">
            <Divider/>
            <div className="buttons">
                {hasQueuesDeletePermission && queueData?.queue?.id && <Button icon={windowWidth > 1248 ? "pi pi-trash" : ''}
                                                                              className="p-button-outlined"
                                                                              label="Видалити"
                                                                              onClick={showDeletionNotification}
                />}
                <Button icon={windowWidth > 1248 ? "pi pi-ban" : ''}
                        className="p-button-outlined"
                        label="Відміна"
                        onClick={() => {
                            showSaveChangesNotification()
                        }}
                />
                {hasQueuesCreatePermission && !queueData?.queue?.id && <Button icon={windowWidth > 1248 ? "pi pi-save" : ''}
                                                                               className=""
                                                                               label="Створити та зберегти"
                                                                               onClick={() => {
                                                                                   createCampaign('')
                                                                               }}
                />}
                {hasQueuesUpdatePermission && queueData?.queue?.id && <Button icon={windowWidth > 1248 ? "pi pi-save" : ''}
                                                                              label="Зберегти"
                                                                              onClick={() => {
                                                                                  updateCampaign('')
                                                                              }}
                />}
            </div>
        </div>
    );

    return (
        <Dialog
            header="Налаштування черги"
            footer={archiveTableToggle ? footer : ''}
            visible={dialogVisible}
            dismissableMask={false}
            closeOnEscape={false}
            draggable={true}
            blockScroll={true}
            position="top"
            className='dialogInfo'
            style={{width: '65vw', maxWidth: "1200px", minHeight: "80vh", zIndex: '1101px !important'}}
            onHide={() => showSaveChangesNotification()}
        >
            {queueData && <div className="company-info-popup">
                <ConfirmDialog visible={showDeleteNotification} onHide={() => setShowDeleteNotification(false)} message={deleteQueueQuestion}
                               icon="pi pi-exclamation-triangle" acceptLabel="Продовжити" rejectLabel="Відмінити" accept={() => deleteCampaign()}/>
                {!companyStateSave && <ConfirmDialog visible={showSaveChangeNotification} onHide={() => setShowSaveChangeNotification(false)} message={saveChangeMessage}
                                                     icon="pi pi-exclamation-triangle" acceptLabel="Зберегти" rejectLabel="Відмінити" reject={() => closeDialogVisible()} accept={() => {
                    updateCampaign('with_close')
                }}/>}
                {companyStateSave && <ConfirmDialog visible={showSaveChangeNotification} onHide={() => setShowSaveChangeNotification(false)} message={saveChangeMessage}
                                                    icon="pi pi-exclamation-triangle" acceptLabel="Зберегти" rejectLabel="Відмінити" reject={() => closeDialogVisible()} accept={() => {
                    createCampaign('with_close')
                }}/>}
                <QueuesDialogInfo/>
                <Divider style={{margin: '0 0 20px 0'}}/>
                {queueData?.queue?.id &&
                    <>
                        <QueuesListDialogManagement/>
                        <Divider style={{margin: '0 0 20px 0'}}/>
                    </>
                }
                <TabView className="user-dialog-info" activeIndex={activeIndex} onTabChange={(e) => setActiveTabIndex(e)}>
                    <TabPanel header="Загальні налаштування">
                        {queueData && <QueuesListDialogGeneralSettings/>}
                    </TabPanel>
                    {queueData?.queue?.queueType !== 702 && <TabPanel header="Додати операторів">
                        <QueueListDialogUsers/>
                    </TabPanel>}
                    {queueData?.queue?.queueType !== 702 &&<TabPanel header="Розклад роботи">
                        <QueueWorkSetting/>
                    </TabPanel>}
                    {queueData?.queue?.queueType !== 702 &&<TabPanel header="Налаштування ACD">
                        <ACDSettingsTab/>
                    </TabPanel>}
                    {queueData?.queue?.queueType === 702 &&<TabPanel header="Додати IVR">
                        <QueueDialog_IVR_ACD/>
                    </TabPanel>}
                </TabView>
            </div>}
            <Dialog visible={visible} style={{width: '25vw'}} onHide={() => setVisible(false)}>
                <p className="m-0">
                    Застосувати розклад запуску та завершення кампанії?
                </p>
                <div className="flex justify-content-end mt-4">
                    <Button className="mr-2" onClick={() => saveNewScheduler()}>Так</Button>
                    <Button className="p-button-outlined mr-2" onClick={() => cancelSaveScheduler()}>Ні</Button>
                    <Button className="p-button-outlined" onClick={() => setVisible(false)}>Відміна</Button>
                </div>
            </Dialog>
        </Dialog>
    )
}

export default QueuesListDialog
